const light = ({ targetColorPalette }) => targetColorPalette[50];

export default light;
